import { memo } from 'react';
import { TextQueryHint } from '../presentation/Message.QueryHint';

type Props = {
  onClick: () => void;
};

export const ArrowButton = memo(({ onClick }: Props) => {
  return (
    <TextQueryHint
      onClick={onClick}
      value={''} />
  );
});